export default __webpack_public_path__ + "static/media/portfolio10.4ee14aff.svg";